import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const LoginButton = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <button
      onClick={() =>
        loginWithRedirect({
          redirectUri: `${window.location.origin}/welcome`,
          audience: "https://kovedo-system-api"
        })
      }
    >
      {/* Contenido eliminado */}
    </button>
  );
};

export default LoginButton;
